module.exports = __webpack_public_path__ + "static/media/transition_02.d8c9f2d8.mp3";